module.exports = __webpack_public_path__ + "static/media/abus-about.41b3bea9.png";